import { useMediaQuery } from 'react-responsive';
import { Modal } from '../../../components/Modal';
import { useEstabsContext } from '../../../contexts/EstabsContext';
import { useParamsContext } from '../../../contexts/ParamsContext';
import { EstabsClientAddFirst } from '../../estabelecimentos/client/AddFirst';
import { FormHorarioClienteProvider, useFormHorarioClienteContext } from './Form/Context';
import { AgendaForm } from './Form/Form';
import { AgendaList } from './List/List';

export default function AgendaCliente() {
    const { estabsUser } = useEstabsContext();

    return estabsUser.length > 0 ? <Agenda /> : <EstabsClientAddFirst />;
}

// Mesmo limite do Modal, que abaixo dele ocupa a tela inteira e cobre o cabecalho do app.
const MOBILE_MAX_WIDTH = 640;

const MobileBookingSheet = () => {
    const { clear } = useParamsContext();
    const { canStepBack, stepBack, loading } = useFormHorarioClienteContext();

    // Voltar recua uma etapa antes de sair, para nao perder o que o cliente ja escolheu.
    const goBack = () => {
        if (loading) return;
        if (canStepBack) stepBack();
        else clear();
    };

    return (
        <Modal title="Novo agendamento" onClose={goBack} panelClassName="sf-page-sheet">
            <AgendaForm />
        </Modal>
    );
};

const Agenda = () => {
    const { action } = useParamsContext();
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });
    const isBooking = action === 'add';

    if (isBooking && !isMobile) {
        return (
            <FormHorarioClienteProvider>
                <AgendaForm />
            </FormHorarioClienteProvider>
        );
    }

    return (
        <>
            <AgendaList />
            {isBooking && (
                <FormHorarioClienteProvider>
                    <MobileBookingSheet />
                </FormHorarioClienteProvider>
            )}
        </>
    );
};
